import { Container, Row, Col } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "../../sitel/commons/utilities/errorBoundary";
import { ArrowUp } from "../../sitel/commons/ui/components";
import { Logo } from "../../sitel/demon/ui/atoms";
import useOriginApp from "../../services/useOriginApp";
import "./layoutNoTopBar.css";


export default function LayoutNoTopBar() {
    //Making sure we do not get into an insider path with no origin app
    const OriginApp = useOriginApp();
    if(! OriginApp.path ){
        window.location.href = '/central';
    }

    let { pathname } = useLocation();
    const gridColumns = pathname.includes("step5") ? 10 : 6;

    return (
        <>
            <ArrowUp />
            <Container style={{ marginTop: '6rem' }}>
                <ErrorBoundary>
                    <Row className="mx-2 mx-md-0 align-items-center">
                        <Col md={gridColumns} className="m-auto bg-white p-4 border rounded rounded-3">
                            <Logo />
                            <div style={{ marginTop: '2rem' }}>
                                <Outlet />
                            </div>
                        </Col>
                    </Row>
                </ErrorBoundary>
            </Container>
        </>
    );
}
